export type FreightRow = {
  key: string;
  name: string;
  supplierName: string;
  freightName: string;
  type: string;
  defaultLeadTime: string;
  minWeight: string;
  minVolWeight: string;
  sizeType: string;
  region: string;
  loadingType: string;
  costPerPound: number;
  costPerVolume: number;
};

export const freightData: FreightRow[] = [
  {
    key: "FM001",
    name: "FM001",
    supplierName: "Supplier A",
    freightName: "Fast Air UK",
    type: "Air",
    defaultLeadTime: "10d",
    minWeight: "2 lbs",
    minVolWeight: "3 lbs",
    sizeType: "< 2.44 x 3.15 m",
    region: "UK",
    loadingType: "Euro pallet cages",
    costPerPound: 4.8,
    costPerVolume: 34.8,
  },
  {
    key: "FM002",
    name: "FM002",
    supplierName: "Supplier A",
    freightName: "Cargo Sea Route",
    type: "Sea",
    defaultLeadTime: "60d",
    minWeight: "10 lbs",
    minVolWeight: "15 lbs",
    sizeType: "< 2.44 x 3.15 m",
    region: "UK",
    loadingType: "Euro pallets",
    costPerPound: 2.8,
    costPerVolume: 8.8,
  },
  {
    key: "FM003",
    name: "FM003",
    supplierName: "Supplier A",
    freightName: "High-Speed Rail",
    type: "Train",
    defaultLeadTime: "40d",
    minWeight: "5 lbs",
    minVolWeight: "8 lbs",
    sizeType: "< 2.44 x 3.15 m",
    region: "UK",
    loadingType: "Euro pallet cages",
    costPerPound: 3.8,
    costPerVolume: 10.8,
  },
  {
    key: "FM004",
    name: "FM004",
    supplierName: "Supplier B",
    freightName: "Air Express DE",
    type: "Air",
    defaultLeadTime: "40d",
    minWeight: "5 lbs",
    minVolWeight: "8 lbs",
    sizeType: "< 2.44 x 3.15 m",
    region: "UK",
    loadingType: "Euro pallets",
    costPerPound: 3.8,
    costPerVolume: 10.8,
  },
  {
    key: "FM005",
    name: "FM005",
    supplierName: "Supplier B",
    freightName: "Cargo Sea Route",
    type: "Sea",
    defaultLeadTime: "60d",
    minWeight: "10 lbs",
    minVolWeight: "15 lbs",
    sizeType: "< 2.44 x 3.15 m",
    region: "UK",
    loadingType: "Euro pallets",
    costPerPound: 2.8,
    costPerVolume: 8.8,
  },
  {
    key: "FM006",
    name: "FM006",
    supplierName: "Supplier C",
    freightName: "High-Speed Rail",
    type: "Train",
    defaultLeadTime: "40d",
    minWeight: "5 lbs",
    minVolWeight: "8 lbs",
    sizeType: "< 2.44 x 3.15 m",
    region: "UK",
    loadingType: "Euro pallet cages",
    costPerPound: 3.8,
    costPerVolume: 10.8,
  },
];
